import(/* webpackMode: "eager" */ "/app/apps/el-patrimonio/app/[locale]/not-found.tsx");
